import { ref } from 'vue';

// Whether the thread is currently showing original text instead of translations.
// Module level on purpose: the control lives in the conversation header while
// the bubbles that obey it are several levels down, and threading a prop through
// every message component would be worse than one shared flag.
const showOriginals = ref(false);

export function useTranslationView() {
  const toggleOriginals = () => {
    showOriginals.value = !showOriginals.value;
  };

  // Opening a different conversation should not inherit the previous one's view.
  const resetTranslationView = () => {
    showOriginals.value = false;
  };

  return { showOriginals, toggleOriginals, resetTranslationView };
}
